import React from 'react';
import Chip from '@mui/material/Chip';

/**
 * A status as a chip.
 *
 * The colours come from MUI's palette rather than the custom chip variants in
 * theme.js: under MUI 6 those never reach the DOM - every one of them renders as
 * the default chip, which is why a board of them was unreadable at a glance.
 *
 * A status that is not listed keeps the plain chip, so an unfamiliar one still
 * renders its own name rather than borrowing somebody else's colour.
 */
const STATUS_COLOR = {
  // Release runbook tick states.
  pass: 'success',
  fail: 'error',
  blocked: 'warning',
  skipped: 'default',
  reset: 'default',
  'not tested': 'default',
  // Release runbook status.
  draft: 'default',
  testing: 'info',
  shipped: 'success',
  abandoned: 'default',
};

export default function ChipStatus({ status }) {
  const color = STATUS_COLOR[status];

  if (!color) {
    return <Chip label={status} variant={status} />;
  }

  return <Chip label={status} color={color} variant="outlined" size="small" />;
}
